<template>
  <v-container fluid class="mb-12">
    <v-row class="justify-center mb-5">
      <v-card-title>
        {{ $t('subOrder.youNeed') }} {{ ' ' + subOrders.length + ' ' }} {{ $t('subOrder.bins') }}
      </v-card-title>
    </v-row>
    <v-container fluid class="mb-11 pa-0">
      <v-data-table
        :headers="headers"
        :items="subOrders"
        :hide-default-footer="true"
        :disable-pagination="true"
        mobile-breakpoint="0"
      >
        <template v-slot:item.order_id="{ item }">
          <p style="word-break: break-all" class="mb-0">{{ item.order_id }}</p>
        </template>
      </v-data-table>
      <v-divider></v-divider>
    </v-container>
  </v-container>
</template>
<script>
  export default {
    name: 'pickPackShipStep1',
    props: {
      subOrders: {
        type: Array,
        required: true,
      },
    },
    computed: {
      headers: function () {
        return [
          { text: this.$t('subOrder.binId'), value: 'binId', sortable: false, width: '50%', align: 'center' },
          {
            text: this.$t('subOrder.preparationId'),
            value: 'order_id',
            sortable: false,
            width: '50%',
            align: 'center',
          },
        ]
      },
    },
  }
</script>
